export const items = [
  { text: "860 North Dorothy Drive Suite 600", link: null, external: false },
  { text: "Richardson, TX 75081", link: null, external: false },
  { text: "TEL: 972-480-0888", link: null, external: false },
  { text: "FAX: 972-480-8884", link: null, external: false },
  { text: "service@trastarusa.com", link: null, external: false },
];

export const header = { text: "Trastar Inc.", link: "/", external: false };
